// Where a material (and the purchase order it's on) is, in order. `tone` is
// the DataList.Pill colour. Used by the purchase order page and a supplier's
// lists so the names and colours match everywhere.
export const MATERIAL_STATUSES = [
  { value: 'pending order', label: 'Pending order', tone: 'amber' },
  { value: 'ordered', label: 'Ordered', tone: 'blue' },
  { value: 'in transit', label: 'In transit', tone: 'purple' },
  { value: 'received', label: 'Received', tone: 'green' },
  { value: 'picked up by the technician', label: 'Picked up by the technician', tone: 'green' },
];

export const ARCHIVED = { value: 'archived', label: 'Archived', tone: 'grey' };

export const ALL_MATERIAL_STATUSES = [...MATERIAL_STATUSES, ARCHIVED];

// The status for a stored value; unknown values keep their own text.
export const materialStatus = (value) => {
  const key = String(value || '').toLowerCase();
  const found = ALL_MATERIAL_STATUSES.find((status) => status.value === key);
  if (found) return found;
  return { value: key, label: key ? key.charAt(0).toUpperCase() + key.slice(1) : '', tone: 'grey' };
};
